import { PrivacySettings, Time } from 'types/general.types';
import { PreferredIpi } from 'types/ipi.types';
import { PreferredIpn } from 'types/ipn.types';
import { Link } from 'types/api.types';
import { PreferredIsni } from 'types/isni.types';
import { EntityType, ProfileImageSize } from 'types/enums';

export interface Representative {
  firstName?: string;
  lastName?: string;
  company?: string;
  role?: string;
  email?: string;
  publisherIpi?: number;
}

export interface AllPrivacySettings {
  privacySettingsCollab?: {
    basic?: boolean;
    email?: boolean;
    artistName?: boolean;
    reps?: boolean;
  };
  privacySettingsInternal?: {
    basic?: boolean;
    email?: boolean;
    artistName?: boolean;
    idNumbers?: boolean;
    reps?: boolean;
  };
  privacySettingsPublic?: {
    basic?: boolean;
    email?: boolean;
    artistName?: boolean;
    idNumbers?: boolean;
    reps?: boolean;
  };
}

export interface ProfileItem extends AllPrivacySettings {
  guid: string;
  created: Time;
  updated: Time;
  type: ProfileType;
  firstName: string;
  lastName: string;
  displayName: string;
  middleName?: string;
  gender?: string;
  dateOfBirth?: string;
  address?: ProfileAddress;
  preferredIpi?: PreferredIpi;
  preferredIpn?: PreferredIpn;
  preferredIsni?: PreferredIsni;
  privacySettings: PrivacySettings;
  profileImages?: ProfileImage[];
  subject: string;
  initials: string;
  avatarColors?: AvatarColors;
  artistName?: string;
  email?: string;
  representatives?: Representative[];
}

export interface ProfileAddress {
  countryCode?: string;
  primaryAddress?: string;
  secondaryAddress?: string;
  city?: string;
  stateProvinceRegion?: string;
  zipCode?: string;
}

export interface AvatarColors {
  background: string;
  text: string;
}

export interface ProfileCard {
  guid: string;
  subject: string;
  displayName: string;
  initials: string;
  profileImages?: ProfileImage[];
  firstName?: string;
  lastName?: string;
  avatarColors?: AvatarColors;
  countryCode?: string;
  city?: string;
  entityType?: EntityType.COLLABORATOR;
}

export interface Profile extends ProfileItem {
  _links?: _ProfileLinks;
}

export interface _ProfileLinks {
  update: Link;
  self: Link;
  listIpis: Link;
  listIpns: Link;
  listIds: Link;
  createProfileImage?: Link;
  deleteProfileImage?: Link;
  uploadStatus?: Link;
  countryCodesAlpha2DDL: Link;
}

export interface _ProfileListLinks {
  profile: Link;
  update: Link;
  delete: Link;
  self: Link;
  create: Link;
}

export enum ProfileType {
  LEGAL = 'LEGAL',
}

export interface ProfileImage {
  href: string;
  name: ProfileImageSize;
}
export interface SearchProfilesValidationProperties {
  limit: {
    default: number;
    maximum: number;
    minimum: number;
  };
  offset: {
    default: number;
    minimum: number;
  };
  search: {
    maxLength: number;
    minLength: number;
  };
}

export interface InviteCollaboratorValidations {
  properties: {
    inviteeEmail: {
      maxLength: number;
      minLength: number;
    };
    message: {
      maxLength: number;
      minLength: number;
    };
  };
}

export type AccountConnectionProviderId = 'SoundCloud' | 'TuneCore' | 'Connex';

export interface Connection {
  guid?: string;
  name?: string;
  userGuid?: string;
  providerId: AccountConnectionProviderId;
  created?: Time;
  updated?: Time;
  _links: {
    connect?: Link;
    disconnect?: Link;
  };
}

export interface Address {
  city?: string;
  countryCode?: string;
}
